/**
 * Hotfix del alta (relay tren de fixes v4 §1bis) — helpers puros del formulario de alta.
 */
import { API_BASE } from '../lib/api';

/** §1bis.6 — la política no cambia (mín. 8, una mayúscula, un número); se muestra MIENTRAS
 *  se escribe como lista que se va palomeando. */
export function passwordChecks(pw: string): Array<{ label: string; ok: boolean }> {
  return [
    { label: 'Al menos 8 caracteres', ok: pw.length >= 8 },
    { label: 'Una mayúscula', ok: /[A-Z]/.test(pw) },
    { label: 'Un número', ok: /\d/.test(pw) },
  ];
}

/** §1bis.4 — `?ref=CODIGO` (o `?referido=`): mayúsculas, solo [A-Z0-9-], máx. 32. */
export function refFromSearch(search: string): string {
  const p = new URLSearchParams(search);
  const raw = (p.get('ref') ?? p.get('referido') ?? '').toUpperCase().replace(/[^A-Z0-9-]/g, '').slice(0, 32);
  return raw;
}

/** §1bis.9 — SOLO el host del referrer, y solo si viene de otro sitio (nunca la URL completa). */
export function referrerHost(referrer: string, ownHost: string): string | null {
  try {
    if (!referrer) return null;
    const h = new URL(referrer).hostname.toLowerCase();
    if (!h || h === ownHost.toLowerCase()) return null;
    return /^[a-z0-9.-]{1,255}$/.test(h) ? h : null;
  } catch { return null; }
}

export function utmFromSearch(search: string): { utmSource?: string; utmMedium?: string; utmCampaign?: string } {
  const p = new URLSearchParams(search);
  const v = (k: string) => (p.get(k) ?? '').trim().slice(0, 100) || undefined;
  return { utmSource: v('utm_source'), utmMedium: v('utm_medium'), utmCampaign: v('utm_campaign') };
}

export type SignupEvent = 'signup_view' | 'signup_submit' | 'signup_success' | 'signup_validation_error';

/** Payload del evento: SIN email, IP, user agent ni identificadores (lo prueba vitest). */
export function signupEventPayload(
  event: SignupEvent, ctx: { search: string; referrer: string; host: string }, field?: string,
): Record<string, string> {
  const body: Record<string, string> = { event };
  if (event === 'signup_validation_error' && field && /^[A-Za-z]{1,40}$/.test(field)) body.field = field;
  for (const [k, v] of Object.entries(utmFromSearch(ctx.search))) if (v) body[k] = v;
  const host = referrerHost(ctx.referrer, ctx.host);
  if (host) body.referrerHost = host;
  return body;
}

/** Envío best-effort (nunca rompe el alta). `keepalive` para que sobreviva a la redirección. */
export function trackSignup(event: SignupEvent, field?: string): void {
  try {
    const body = signupEventPayload(event, {
      search: window.location.search, referrer: document.referrer, host: window.location.hostname,
    }, field);
    void fetch(`${API_BASE}/public/signup-events`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), keepalive: true,
    }).catch(() => {});
  } catch { /* nunca */ }
}

/** Campo (solo letras) a partir del mensaje de error del servidor, para el embudo. */
export function fieldFromServerError(msg: string): string {
  const m = msg.toLowerCase();
  if (m.includes('correo') || m.includes('email')) return 'email';
  if (m.includes('contraseña') || m.includes('password')) return 'password';
  if (m.includes('nombre')) return 'fullName';
  if (m.includes('verificar') || m.includes('legítima')) return 'captcha';
  return 'server';
}

/** §1bis (decisión Arturo) — identificador recién creado: se muestra en la app tras el alta. */
export const SIGNUP_SLUG_KEY = 'fluidsol.signupSlug';

/**
 * Alta 2 (b) — tras confirmar el correo: a dónde ir y qué dejar escrito en el login. El slug
 * va en la URL (`?negocio=`); el correo NO (solo en el prefill local). null = no hay datos.
 */
export function loginAfterConfirm(
  tenantSlug: string | null | undefined, email: string | null | undefined,
): { url: string; tenantSlug: string; email: string } | null {
  const slug = (tenantSlug ?? '').trim().toLowerCase();
  const mail = (email ?? '').trim().toLowerCase();
  if (!/^[a-z0-9]([a-z0-9-]*[a-z0-9])?$/.test(slug) || !mail.includes('@')) return null;
  return { url: `/login?negocio=${encodeURIComponent(slug)}`, tenantSlug: slug, email: mail };
}
